import React from "react";
import { PHASES } from "../lib/methodology";

export default function PhaseStepper({ current, completed = {}, onSelect, activePhases = null, lockedHint = "Esta fase ainda não foi ativada pelo gestor" }) {
    return (
        <div className="flex items-center gap-2 md:gap-3 w-full overflow-x-auto py-4" data-testid="phase-stepper">
            {PHASES.map((phase, idx) => {
                const isDone = completed[String(phase.num)]?.completed;
                const isActive = current === phase.num;
                const isLocked = activePhases !== null && !activePhases.includes(phase.num);
                return (
                    <React.Fragment key={phase.num}>
                        <button
                            onClick={() => !isLocked && onSelect && onSelect(phase.num)}
                            disabled={isLocked}
                            title={isLocked ? lockedHint : undefined}
                            className={`flex items-center gap-3 shrink-0 focus:outline-none group ${isLocked ? "opacity-40 cursor-not-allowed" : ""}`}
                            data-testid={`phase-btn-${phase.num}`}
                        >
                            <span className={`phase-dot ${isActive ? "active" : ""} ${isDone ? "done" : ""}`}>
                                {isLocked ? "🔒" : (isDone ? "✓" : phase.num)}
                            </span>
                            <span className={`text-sm whitespace-nowrap ${isActive ? "text-[#0d1628] font-medium" : "text-[#52525b]"} group-hover:text-[#0d1628]`}>
                                {phase.title}
                            </span>
                        </button>
                        {idx < PHASES.length - 1 && <div className="phase-line hidden md:block" />}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
